
Mode:
<label><input type="radio" name="mode" value="tables" [(ngModel)]="mode"> Tables</label>
<label><input type="radio" name="mode" value="enums" [(ngModel)]="mode"> Enums</label>
<label><input type="radio" name="mode" value="tableEditor" [(ngModel)]="mode"> Table Editor</label>
<br><br>

<div *ngIf="mode === 'tables'">
  Table: 
  <select [(ngModel)]="table" (ngModelChange)="onTableChange($event)">
    <option *ngFor="let tbl of tables" [ngValue]="tbl">{{ variableToDisplay(tbl.Name) }}</option>
  </select>

  Current Version:
  <select [(ngModel)]="currentChangeset" (ngModelChange)="onChangesetChange($event)">
    <option *ngFor="let cs of changesets" [ngValue]="cs">{{ cs.TableChangesetId + " (by " + cs.UserName + " on " + formatDate(cs.Created) + ")" }}</option>
  </select>

  Compare To:
  <select [(ngModel)]="compareChangeset" (ngModelChange)="onCompareChange($event)">
    <option *ngFor="let cs of comparableChangesets" [ngValue]="cs">{{ cs.TableChangesetId + " (by " + cs.UserName + " on " + formatDate(cs.Created) + ")" }}</option>
  </select>
  <br><br>

  <table>
    <thead>
      <tr>
        <th>ID</th>
        <th>Enabled</th>
        <th>Order</th>
        <th *ngFor="let column of columns">
          {{ getDisplayHeading(column) }}
          <span class="tooltip"> 
            <mat-icon>info</mat-icon>
            <span class="tooltiptext">
              <span><b>---Column Details---</b></span>
              <span><br><b>Name:</b> {{ column.Name }}</span>
              <span *ngIf="column.Description"><br><b>Description:</b> {{ column.Description }}</span>
              <span><br><b>Data Type:</b> {{ getTypeString(column) }}</span>
              <span *ngIf="column.DecimalDigits"><br><b>Decimal Digits:</b> {{ column.DecimalDigits }}</span>
              <span *ngIf="column.ContextId"><br><b>Measurement Type:</b> {{ getContextString(column) }}</span>
              <span *ngIf="column.UnitId"><br><b>Unit Type:</b> {{ getUnitString(column) }}</span>
              <span *ngIf="column.EnumType"><br><b>Enum Type:</b> {{ variableToDisplay(column.EnumType) }}</span>
            </span>
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <!-- <tr>
        <td></td>
        <td></td>
        <td></td>
        <td *ngFor="let column of columns">
          <select *ngIf="column.TypeId === 6" [(ngModel)]="columnFilters[column.Name]" (ngModelChange)="filterChanged()">
            <option *ngFor="let option of getColumnEnumValues(column)" [ngValue]="option.CodeId">{{ option.Label }}</option>
          </select>
        </td>
      </tr> -->
      <tr *ngFor="let row of currentData" draggable="true" (dragstart)="onDragStart($event, row)" (dragover)="onDragOver($event)" (drop)="onDrop($event, row)">
        <td [ngClass]="{'new': isDataNew(row)}">{{ row.DataId }}</td>
        <td [ngClass]="{'modified': isDataModified(row, 'IsEnabled'), 'new': isDataNew(row)}">
          <input type="checkbox" [(ngModel)]="row.IsEnabled" />
          <mat-icon (click)="deleteRow(row)" *ngIf="isDataNew(row) && currentChangeset == compareChangeset">delete</mat-icon>
        </td>
        <td [ngClass]="{'modified': isDataModified(row, 'SortOrder'), 'new': isDataNew(row)}">{{ row.SortOrder }}</td>
        <td *ngFor="let column of columns" (click)="onCellClick(row, column)"
            [ngClass]="{'modified': isDataModified(row, column.Name), 'new': isDataNew(row)}">
          <span *ngIf="isEditingCell(row, column)">
            <input *ngIf="column.TypeId <= 3" [(ngModel)]="editValue" (ngModelChange)="cellChanged()" /> {{ getUnitString(column) }}
            <select *ngIf="column.TypeId === 6" [(ngModel)]="editValue" (ngModelChange)="cellChanged()">
              <option *ngFor="let option of editEnumValues" [ngValue]="option.CodeId" >{{ option.Label }}</option>
            </select>
          </span>
          <span *ngIf="!isEditingCell(row, column)">
            {{ getDisplayValue(row, column) }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>

  <br>
  <button (click)="addNewRow()">
    <mat-icon style="vertical-align: middle;">add</mat-icon>
    <span style="vertical-align: middle;">Add New Row</span>
  </button> 
  <button (click)="saveChanges()">
    <mat-icon style="vertical-align: middle;">save</mat-icon>
    <span style="vertical-align: middle;">Save Changes</span>
  </button>
  <br>
</div>
<div *ngIf="mode === 'enums'">

</div>